import React, { useMemo } from 'react';

import type { PageHeaderToolbarProps } from '../../types';

import { ActionButton } from './components/ActionButton';

export const MOBILE_STYLE = 'justify-center gap-[var(--space-3,8px)] self-stretch';
export const DESKTOP_STYLE = 'justify-end gap-[var(--space-2,12px)] self-auto';

export const PageHeaderToolbar: React.FC<PageHeaderToolbarProps> = ({
	actionButtons = [],
	actionButtonsOrientation = 'ltr',
	mobile = false,
}: PageHeaderToolbarProps) => {
	const sortedActionButtons = useMemo(() => {
		return actionButtonsOrientation === 'rtl' ? [...actionButtons].reverse() : actionButtons;
	}, [actionButtons, actionButtonsOrientation]);

	const variantStyle = useMemo(() => (mobile ? MOBILE_STYLE : DESKTOP_STYLE), [mobile]);

	return (
		<nav className={`flex items-start ${variantStyle}`} data-testid="page-header-actions" aria-label="Page actions">
			{sortedActionButtons.map((buttonType) => (
				<ActionButton key={`header-button-${buttonType}`} type={buttonType} mobile={mobile} />
			))}
		</nav>
	);
};
